export function serialize(record) {
  return JSON.stringify(record);
}

export function deserialize(json) {
  const {
    id,
    parent,
    code,
    description,
    from_date,
    to_date,
    iscode,
    level,
    ett_class
  } = json;

  return {
    id,
    parentId: parent,
    code,
    description,
    fromDate: from_date,
    toDate: to_date,
    iscode,
    level,
    ettClass: ett_class
  };
}



// WEBPACK FOOTER //
// ./src/serializers/GngNode.js